import { useState } from "react";
import { ContentContainer, FormSubsection, MUITableD } from "components";
import { Button } from "@mui/material";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MessageTrace from "./MessageTrace";
import DexComparison from "./DexComparison";

type Props = {
  data: any;
};

interface Selections {
  dataIndex: any,
  index: any
}

interface DexRecord {
  record1: any,
  record2: any
}

const SearchResult = (props: Props) => {
  const { data } = props;
  const { t } = useTranslation("telemetry"); // Get translation
  const navigate = useNavigate();
  const [record, setRecord] = useState(null)
  const [selection, setSelection] = useState<Selections[]>([]);
  const [dexRecord, setDexRecord] = useState<DexRecord | undefined>(undefined);

  const getDexReason = (dexm: any): string => {
    var ret = "";
    if (dexm && dexm.dexReason != null) {
      if (dexm.dexReason === 1) {
        ret = "Fill Key";
      } else {
        ret = "Audit";
      }
    }
    return ret;
  }

  const columns = [
    { name: "deliveryStatus", label: t("Status") },
    { name: "lastUpdatedAt", label: t("Last Update") },
    { name: "processingStatus", label: t("Processing Info") },
    { name: "dexMetadata", label: t("DEX Reason"), options: { customBodyRender: (value: any) => getDexReason(value) } },
    { name: "destinationDelivery", label: t("# of Destinations"), options: { customBodyRender: (value: Array<any>) => value.length }, }
  ];

  const options: MUIDataTableOptions = {
    filter: false,
    resizableColumns: true,
    download: false,
    print: false,
    responsive: "standard",
    draggableColumns: { enabled: false },
    selectableRows: "multiple",
    rowsPerPage: 100,
    rowsPerPageOptions: [100, 200, 500],
    onRowSelectionChange: (currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[]) => {
      setSelection(allRowsSelected);
    },
    onRowClick(rowData, rowMeta) {
      let record = data[rowMeta.dataIndex];
      console.log(record);
      setRecord(record);
    },
    sortOrder: { name: "deliveryDateTime", direction: "desc" },
  };

  const handleTraceModalClose = () => {
    setRecord(null);
  }

  const handleCompareModalClose = () => {
    setDexRecord(undefined);
  }

  const handleCompareClick = () => {
    let dr: DexRecord = { record1: data[selection[0].dataIndex], record2: data[selection[1].dataIndex] };
    setDexRecord(dr);
  }

  return (
    <>
      <ContentContainer py={4}>
        <FormSubsection title={t("VDI Transactions")}>
          {(selection.length === 2) &&
            <Button
              color="error"
              startIcon={<SearchOutlinedIcon />}
              sx={{
                mr: 4
              }}
              onClick={() => { handleCompareClick() }}
              variant="outlined"
              style={{ marginBottom: 20 }}
            >
              Compare DEX Data
            </Button>
          }
          <MUIDataTable
            title=""
            data={data}
            columns={columns}
            options={options}
          />
        </FormSubsection>
      </ContentContainer>

      <Modal open={!(record === null)} onClose={() => handleTraceModalClose()}>
        <MessageTrace data={record} />
      </Modal>

      <Modal open={!(dexRecord === undefined)} onClose={() => handleCompareModalClose()}>
        <DexComparison record1={dexRecord?.record1} record2={dexRecord?.record2} />
      </Modal>
    </>
  );
};

export default SearchResult;
